module.exports = __webpack_public_path__ + "static/media/others-asset.213b4aeb.png";